import { render, staticRenderFns } from "./lecturerYwEdit.vue?vue&type=template&id=f55db3e0"
import script from "./lecturerYwEdit.vue?vue&type=script&lang=js"
export * from "./lecturerYwEdit.vue?vue&type=script&lang=js"
import style0 from "./lecturerYwEdit.vue?vue&type=style&index=0&id=f55db3e0&prod&lang=less"
import style1 from "./lecturerYwEdit.vue?vue&type=style&index=1&id=f55db3e0&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports